import React, { FC, useState } from 'react';
import styled from 'styled-components';
import { ProductDetailStage } from './ProductDetailStage';
import { ProductDetailSummary, ProductDetailSummaryProps } from './ProductDetailSummary';
import { SimpleAccordion } from '../../SimpleAccordion';
import { FlexboxVertical } from '../../Layout';
import { ProductDetailMetaInfoSection } from './meta-info/ProductDetailMetaInfoSection';
import { ProductDetailBenefitsSection } from './benefits/ProductDetailBenefitsSection';
import { ProductDetailCertificatesSection } from './certificates/ProductDetailCertificatesSection';

const MetaInfoWrapper = styled(FlexboxVertical)`
	padding: 5rem 0 1rem;
`;

interface Props extends ProductDetailSummaryProps {
  //
}
export const ProductDetailPage: FC<Props> = ({ product, ...props }) => {
  const [activeSections, setActiveSections] = useState<string[]>([]);

  const setSectionActive = (id: string, active: boolean) => {
    const nextSections = activeSections.filter((value) => value !== `${id}`);
    if (active) {
      nextSections.push(`${id}`);
    }
    setActiveSections(nextSections);
  }

  return (
    <>
      <ProductDetailStage product={product} />

      <MetaInfoWrapper>
        {
          product?.metaProduct?.productFeatures &&
          <SimpleAccordion
            title={'Produktmerkmale'}
            collapsed={!activeSections.includes('acc0')}
            onClick={(collapsed) => setSectionActive('acc0', collapsed)}
          >
            <ProductDetailMetaInfoSection product={product} visible={activeSections.includes('acc0')} />
          </SimpleAccordion>
        }
        {
          product?.metaProduct?.productBenefit &&
          <SimpleAccordion
            title={'Vorteile'}
            collapsed={!activeSections.includes('acc1')}
            onClick={(collapsed) => setSectionActive('acc1', collapsed)}
          >
            <ProductDetailBenefitsSection product={product} visible={activeSections.includes('acc1')} />
          </SimpleAccordion>
        }
        {
          product?.metaProduct?.productCertificates &&
          <SimpleAccordion
            title={'Zertifikate'}
            collapsed={!activeSections.includes('acc2')}
            onClick={(collapsed) => setSectionActive('acc2', collapsed)}
          >
            <ProductDetailCertificatesSection product={product} visible={activeSections.includes('acc2')} />
          </SimpleAccordion>
        }
      </MetaInfoWrapper>

      <ProductDetailSummary
        product={product}
        {...props}
      />
    </>
  )
}
